// CB-REQ INV-A12 at v1.955: a line at a venue that keeps stock is held from the venue first, then
// the depot, and says so on the line — "4 at Crown Melbourne · 2 from depot". A line drawing on the
// depot alone says so too — "6 from the depot" — so every line answers "from where" the same way
// (the operator's decision at slice 3's checks, 2026-10-01; it had said nothing, as noise).

export interface PoolShare {
  readonly name: string;
  readonly kind: 'depot' | 'venue';
  readonly held: number;
}

export function heldFrom(pools: readonly PoolShare[]): string | null {
  const said = pools
    .map((p) =>
      p.kind === 'venue'
        ? p.held > 0
          ? `${p.held} at ${p.name}`
          : `none free at ${p.name}`
        : p.held > 0
          ? `${p.held} from the depot`
          : null,
    )
    .filter(Boolean)
    .join(' · ');
  return said || null;
}
